// Module
var code = `<div class="confirmation-screen-container">
    <div class="confirmation-screen-entries">
        {{#each entries}}
            <div class="js-entry">
                <div class="js-tercera-label first-column">{{.caption}}</div>
                <div class="js-tercera-label second-column">{{.text}}</div>
            </div>
        {{/each}}
    </div>
    <terceraMessageBox name="OldMsgBox" messageBoxText="{{msgBoxText}}" />
</div>
`;
// Exports
export default code;